module.exports = __webpack_public_path__ + "static/media/signage-indoor-img35.4b7cde07.jpg";